import { getContestUgcMediaAndVoteCount } from 'api/ugc';

const UPDATE_GAME_STATE = 'gameState/UPDATE_GAME_STATE';

export const defaultState = {
    campaignVoteCount: 0,
    campaignPortfolioCount: 0
};
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_GAME_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function updateCampaignVoteCount() {
    return async (dispatch, getState) => {
        const {
            promo: { uuid: promoUUID }
        } = getState();
        const {
            payload: { counts, votes }
        } = await getContestUgcMediaAndVoteCount(promoUUID);

        dispatch({
            type: UPDATE_GAME_STATE,
            payload: {
                campaignVoteCount: votes,
                campaignPortfolioCount: counts
            }
        });
    };
}
